import { v2Colors } from "../tokens/color";
import { getRgbaColor } from "../shared/utils/color/color";
export const linkStyles = {
    inline: {
        color: v2Colors.text.activePrimary,
        textDecoration: 'underline',
        padding: '0.4rem',
        margin: '0 0.1rem',
        borderRadius: '0.6rem',
        transition: '140ms padding ease',
        '&:hover': {
            backgroundColor: `${getRgbaColor(v2Colors.background.darkest, 0.03)} !important`,
        },
        '&:focus': {
            outlineColor: v2Colors.border.activeSecondary,
            padding: '0.4rem 0.6rem',
            backgroundColor: `${getRgbaColor(v2Colors.background.darkest, 0.06)} !important`,
        },
    },
    endOfLine: {
        color: v2Colors.text.activePrimary,
        textDecoration: 'underline',
        padding: '0.4rem',
        margin: '0 0.1rem',
        borderRadius: '0.6rem',
        paddingRight: 0,
        transition: '140ms padding ease',
        '&:hover': {
            backgroundColor: `${getRgbaColor(v2Colors.background.darkest, 0.03)} !important`,
        },
        '&:focus': {
            outlineColor: v2Colors.border.activeSecondary,
            padding: '0.4rem 0.6rem',
            backgroundColor: `${getRgbaColor(v2Colors.background.darkest, 0.06)} !important`,
        },
    },
};
